import React, { useMemo } from 'react';
import { Dropdown } from 'antd';
import { ClockCircleOutlined, DownOutlined } from '@ant-design/icons';
import { WorkScheduleHelpers } from '../../../../../services/utils/schedule/WorkScheduleHelpers';
import { OrderMethod } from '../../../../../types/constants';
import useBusinessHours from '../../../../../hooks/availability/useBusinessHours';
import { ItemType } from 'antd/lib/menu/interface';
import moment from 'moment-timezone';
import { StoreDetails } from '../../../../../types/store';
import useCurrentTime from '../../../../../hooks/utility/useCurrentTime';

type Props = {
  data: StoreDetails;
};

const Schedule = ({ data }: Props) => {
  const { formattedTime } = useCurrentTime({ format: 'HH:mm' });
  const { isOrderMethodOpen, findScheduleUnit } = useBusinessHours(data);
  const isOpen = isOrderMethodOpen(OrderMethod.Pickup);
  const scheduleUnit = findScheduleUnit(OrderMethod.Pickup);
  const groupedWorkSchedule = useMemo(
    () => WorkScheduleHelpers.groupByDay(data?.availability.work_schedule),
    [data?.availability.work_schedule],
  );
  const items: ItemType[] = useMemo(
    () =>
      groupedWorkSchedule.map((item) => ({
        key: item.day,
        label: (
          <div className="flex justify-between w-64">
            <p className="text-xs">{moment().day(item.day).format('dddd')}</p>
            <p className="text-xs font-medium">{item.entries}</p>
          </div>
        ),
        type: 'item',
      })),
    [groupedWorkSchedule],
  );
  const unitDetails = WorkScheduleHelpers.stringifyUnitDetails(
    isOpen ? scheduleUnit.close : scheduleUnit.open,
  );
  const localTimeLabel = `Local time: ${formattedTime}`;
  const label = `${localTimeLabel} - ${isOpen ? 'Closes' : 'Opens'} ${unitDetails}`;

  return (
    <Dropdown menu={{ items }} trigger={['click']} className="cursor-pointer">
      <div className="flex gap-x-2 items-center justify-between">
        <ClockCircleOutlined className="text-md" />
        <p className="mr-auto text-slate-600 text-sm">{label}</p>
        <DownOutlined className="text-slate-600 hover:bg-slate-200 py-1 px-2 rounded-lg duration-200" />
      </div>
    </Dropdown>
  );
};

export default Schedule;
